export default __webpack_public_path__ + "static/media/gallery_11.8f3c1125.jpg";